
import { Component, ErrorInfo } from "react";

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ComponentProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    hasError: false
  };

  constructor( props: ComponentProps ) {
    super(props);
  }

  static getDerivedStateFromError( error: Error ) {
    return { hasError: true }; // Update State so next Render uses Fallback UI
  }

  componentDidCatch( error: Error, info: ErrorInfo ) {
    // TODO: Log to Error Reporting Service
    console.log( error, info );
  }

  render() {
    if( this.state.hasError ) {
      // Fallback UI
      return <h1>Uh oh! Something went wrong. We logged this issue and will look into it</h1>
    }

    return this.props.children; // All good, render as normally would
  }

}
